import EventHandler from '@pixelunion/events';

import NavDesktopMenu from './NavDesktopMenu'; // eslint-disable-line import/no-cycle

export default class NavDesktopParent {
  constructor(el, options) {
    this.listitem = el;
    this.link = null;
    this.submenu = null;
    this._isOpen = false;
    this._isMeganav = false;
    this.menu = null;
    this.parentMenu = options.parentMenu;
    this.closeSiblings = this.parentMenu.closeSiblings;

    this.events = new EventHandler();

    const { children } = this.listitem;

    for (let i = 0; i < children.length; i++) {
      if (children[i].dataset.mainNavLink !== undefined) {
        this.link = children[i];
      } else if (children[i].dataset.mainNavSubmenu !== undefined) {
        this.submenu = children[i];
      }
    }

    this._isMeganav = this.submenu && this.submenu.classList.contains('navigation-meganav');

    this.open = () => {
      this._open();
    };
    this.close = () => {
      this._close();
    };
    this.closeEsc = e => {
      if (e.key === 'Escape') {
        this.link.focus();
        this.close();
      }
    };

    this.closeTimer = null;
    this.mouseover = () => {
      clearTimeout(this.closeTimer);
      this.open();
    };

    this.mouseout = () => {
      this.closeTimer = setTimeout(this.close, 400);
    };

    this.click = e => {
      e.stopPropagation();
      // if already open, continue to link destination
      if (e.target.dataset.mainNavLink === undefined || this._isOpen) { return; }
      e.preventDefault();
      this.open();
    };
    this.focusin = e => {
      e.stopPropagation();
      this.closeSiblings(this);
    };

    this.events.register(this.listitem, 'mouseover', () => this.mouseover());
    this.events.register(this.listitem, 'mouseout', () => this.mouseout());
    this.events.register(this.listitem, 'touchend', e => this.click(e));
    this.events.register(this.listitem, 'click', e => this.click(e));
    this.events.register(this.listitem, 'focusin', e => this.focusin(e));

    this.events.register(document.body, 'click', () => this.close());
    this.events.register(document.body, 'focusin', () => this.close());
  }

  get isOpen() {
    return this._isOpen;
  }

  get isMeganav() {
    return this.submenu.classList.contains('navigation-meganav');
  }

  get blockId() {
    return this.submenu.dataset.meganavId;
  }

  forceOpen() {
    return this._open(true);
  }

  forceClose() {
    return this._close(true);
  }

  _open() {
    if (this._isOpen) return;

    this._isOpen = true;
    this.closeSiblings(this);

    this.closeEscEvent = this.events.register(window, 'keydown', e => this.closeEsc(e));

    if (!this.menu && !this.submenu.classList.contains('navigation-meganav')) {
      this.menu = new NavDesktopMenu(this.submenu);
    }

    this.submenu.classList.add('open');

    this.submenu.classList.remove('alternate-drop');

    // Check for if dropdown is offscreen and style accordingly
    const menuBounds = this.submenu.getBoundingClientRect();

    if (menuBounds.right > document.documentElement.clientWidth) {
      this.submenu.classList.add('alternate-drop');
    }

    this.link.setAttribute('aria-expanded', true);
  }

  _close() {
    if (!this._isOpen) return;

    if (this.menu) {
      this.menu.unload();
      this.menu = null;
    }

    this._isOpen = false;

    this.events.unregister(this.closeEscEvent);

    this.submenu.classList.remove('open');
    this.submenu.classList.remove('alternate-drop');
    this.link.setAttribute('aria-expanded', false);
    this.parentMenu.openSelectedBlock();
  }

  unload() {
    this.forceClose();
    this.events.unregisterAll();

    window.removeEventListener('keydown', this.closeEsc);
  }
}
